import { colorMap, GenetecColors } from '@/utils/constants';

export default (breakpoints: any) => ({
  '.bg-color-white': {
    backgroundColor: `${colorMap.white} !important`,
  },
  '.bg-color-eggshell': {
    backgroundColor: `${colorMap.eggshell} !important`,
  },
  '.bg-color-medium-gray': {
    backgroundColor: `${colorMap['medium-gray']} !important`,
  },
  '.bg-color-charcoal': {
    backgroundColor: `${colorMap.charcoal} !important`,
  },
  '.bg-color-dark-gray': {
    backgroundColor: `${colorMap['dark-gray']} !important`,
  },
  '.bg-color-black': {
    backgroundColor: `${colorMap.black} !important`,
  },
  '.bg-color-blue': {
    backgroundColor: `${GenetecColors.blue} !important`,
  },
  '.bg-color-none': {
    backgroundColor: 'transparent !important',
  },
  '.bg-color-white-md': {
    [breakpoints.up('md')]: {
      backgroundColor: `${colorMap.white} !important`,
    },
  },
  '.bg-color-eggshell-md': {
    [breakpoints.up('md')]: {
      backgroundColor: `${colorMap.eggshell} !important`,
    },
  },
  '.bg-color-medium-gray-md': {
    [breakpoints.up('md')]: {
      backgroundColor: `${colorMap['medium-gray']} !important`,
    },
  },
  '.bg-color-charcoal-md': {
    [breakpoints.up('md')]: {
      backgroundColor: `${colorMap.charcoal} !important`,
    },
  },
  '.bg-color-dark-gray-md': {
    [breakpoints.up('md')]: {
      backgroundColor: `${colorMap['dark-gray']} !important`,
    },
  },
  '.bg-color-black-md': {
    [breakpoints.up('md')]: {
      backgroundColor: `${colorMap.black} !important`,
    },
  },
  '.bg-color-blue-md': {
    [breakpoints.up('md')]: {
      backgroundColor: `${GenetecColors.blue} !important`,
    },
  },
  '.bg-color-none-md': {
    [breakpoints.up('md')]: {
      backgroundColor: 'transparent !important',
    },
  },

  '.text-color-white': {
    color: `${colorMap.white} !important`,
  },
  '.text-color-eggshell': {
    color: `${colorMap.eggshell} !important`,
  },
  '.text-color-medium-gray': {
    color: `${colorMap['medium-gray']} !important`,
  },
  '.text-color-charcoal': {
    color: `${colorMap.charcoal} !important`,
  },
  '.text-color-dark-gray': {
    color: `${colorMap['dark-gray']} !important`,
  },
  '.text-color-black': {
    color: `${colorMap.black} !important`,
  },
  '.text-color-blue': {
    color: `${GenetecColors.blue} !important`,
  },
  '.text-color-none': {
    color: 'transparent !important',
  },
  '.text-color-white-md': {
    [breakpoints.up('md')]: {
      color: `${colorMap.white} !important`,
    },
  },
  '.text-color-eggshell-md': {
    [breakpoints.up('md')]: {
      color: `${colorMap.eggshell} !important`,
    },
  },
  '.text-color-medium-gray-md': {
    [breakpoints.up('md')]: {
      color: `${colorMap['medium-gray']} !important`,
    },
  },
  '.text-color-charcoal-md': {
    [breakpoints.up('md')]: {
      color: `${colorMap.charcoal} !important`,
    },
  },
  '.text-color-dark-gray-md': {
    [breakpoints.up('md')]: {
      color: `${colorMap['dark-gray']} !important`,
    },
  },
  '.text-color-black-md': {
    [breakpoints.up('md')]: {
      color: `${colorMap.black} !important`,
    },
  },
  '.text-color-blue-md': {
    [breakpoints.up('md')]: {
      color: `${GenetecColors.blue} !important`,
    },
  },
  '.text-color-none-md': {
    [breakpoints.up('md')]: {
      color: 'transparent !important',
    },
  },
});
